/* Shopify chat bubble — custom support avatar */
(function () {
  const AVATAR_URL = 'https://cdn.shopify.com/s/files/1/0625/5263/7637/files/gw9-kevin-support.png?v=1780963336';
  const STYLE_ID = 'gw9-chat-avatar';
  const css = [
    'button.activator {',
    '  width: 68px !important;',
    '  height: 68px !important;',
    '  min-width: 68px !important;',
    '  min-height: 68px !important;',
    '  padding: 0 !important;',
    '  border: 0 !important;',
    '  border-radius: 50% !important;',
    '  background-color: #bde7f5 !important;',
    '  background-image: url("' + AVATAR_URL + '") !important;',
    '  background-size: cover !important;',
    '  background-position: center 15% !important;',
    '  background-repeat: no-repeat !important;',
    '  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.28) !important;',
    '  overflow: visible !important;',
    '  position: relative !important;',
    '  gap: 0 !important;',
    '}',
    '.activator-nudge {',
    '  overflow: visible !important;',
    '}',
    'button.activator .activator__icon,',
    'button.activator .activator__label,',
    'button.activator .activator__indicator {',
    '  display: none !important;',
    '}',
    'button.activator::after {',
    '  content: "" !important;',
    '  position: absolute !important;',
    '  top: 2px !important;',
    '  right: 2px !important;',
    '  width: 10px !important;',
    '  height: 10px !important;',
    '  border-radius: 50% !important;',
    '  background: #e53b37 !important;',
    '  box-shadow: 0 0 0 2px #ffffff !important;',
    '  z-index: 2 !important;',
    '  pointer-events: none !important;',
    '}'
  ].join('\n');

  function runtimeRoot() {
    const chat = document.querySelector('shopify-chat');
    const runtime = chat && chat.shadowRoot && chat.shadowRoot.querySelector('shopify-agent-runtime');
    return runtime && runtime.shadowRoot;
  }

  function applyAvatar() {
    const root = runtimeRoot();
    if (!root || !root.querySelector('button.activator')) return false;

    let style = root.querySelector('#' + STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      root.appendChild(style);
    }
    if (style.textContent !== css) style.textContent = css;

    if (!root.__gw9AvatarWatch) {
      root.__gw9AvatarWatch = true;
      new MutationObserver(function () {
        if (!root.querySelector('#' + STYLE_ID)) applyAvatar();
      }).observe(root, { childList: true });
    }

    return true;
  }

  function init() {
    let observer;

    const tryApply = function () {
      if (!applyAvatar()) return false;
      if (observer) observer.disconnect();
      return true;
    };

    if (tryApply()) return;

    let tries = 0;
    const timer = setInterval(function () {
      tries += 1;
      if (tryApply() || tries > 40) clearInterval(timer);
    }, 500);

    observer = new MutationObserver(function () {
      if (tryApply()) clearInterval(timer);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Homepage header glass bar — fade on scroll */
(function () {
  const bar = document.querySelector('.header__bar-bg');
  if (!bar || !document.body.classList.contains('template-index')) return;

  let ticking = false;

  const getFadeDistance = () => {
    const headerHeight = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height')
    );
    return Math.max(headerHeight || bar.offsetHeight || 0, 120);
  };

  const updateBarOpacity = () => {
    const fadeDistance = getFadeDistance();
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    const progress = Math.min(Math.max(scrollY / fadeDistance, 0), 1);
    const opacity = 1 - progress;

    bar.style.setProperty('--header-bar-scroll-opacity', String(opacity));
    bar.style.setProperty('--header-bar-blur', `${14 * opacity}px`);
    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(updateBarOpacity);
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', updateBarOpacity);
  document.addEventListener('DOMContentLoaded', updateBarOpacity);
  updateBarOpacity();
})();
